// Route constants để quản lý tập trung
export const ROUTES = {
  // Public routes
  LOGIN: "/dang-nhap",

  // Protected routes
  DASHBOARD: "/trang-chu",
  USERS: "/users",
  ROLES: "/roles",
  CATEGORIES: "/categories",
  ARTICLES: "/articles",
  CREATE_ARTICLE: "/articles/create",
  EDIT_ARTICLE: "/articles/:id/edit",
  IMAGES: "/images",
  PAGES: "/pages",
  CREATE_PAGE: "/pages/create",
  EDIT_PAGE: "/pages/:id/edit",
  BLOG_POSTS: "/blog-posts",
  CREATE_BLOG_POST: "/blog-posts/create",
  EDIT_BLOG_POST: "/blog-posts/:id/edit",
  MENUS: "/menus",
  SIDEBAR: "/sidebar",
  TRENDING_MOVIES: "/trending-movies",
  FILM_LIST: "/film-list",
  AUTHORS: "/authors",
  ROBOT_TXT: "/robot-txt",
  INFORMATION: "/information",
  WIDGETS: "/widgets",
  COMMENTS: "/comments",
  SETTINGS: "/settings",
  PROFILE: "/profile",
  REDIRECTIONS: "/redirections",
  AD_SLOTS: "/ad-slots",
  SERIES: "/series",

  // Actor & Director
  ACTORS: "/actors",
  CREATE_ACTOR: "/actors/create",
  EDIT_ACTOR: "/actors/:id/edit",
  DIRECTORS: "/directors",
  CREATE_DIRECTOR: "/directors/create",
  EDIT_DIRECTOR: "/directors/:id/edit",

  // KKMovie & Sync
  KKMOVIES: "/kkmovies",
  KKMOVIE_EPISODES: "/kkmovies/:id/episodes",
  KKPHIM_SYNC: "/kkphim-sync",
  OPHIM_SYNC: "/ophim-sync",
  MOVIE_IMPORT: "/movie-import",

  // System
  CACHE: "/cache",

  // Default redirect
  HOME: "/",
} as const;

// Route metadata cho navigation
export const ROUTE_METADATA = {
  [ROUTES.LOGIN]: {
    title: "Đăng nhập",
    isPublic: true,
  },
  [ROUTES.DASHBOARD]: {
    title: "Dashboard",
    isPublic: false,
  },
  [ROUTES.USERS]: {
    title: "Người dùng",
    isPublic: false,
    permission: "user",
  },
  [ROUTES.ROLES]: {
    title: "Vai trò",
    isPublic: false,
    permission: "role",
  },
  [ROUTES.CATEGORIES]: {
    title: "Danh mục",
    isPublic: false,
    permission: "category",
  },
  [ROUTES.ARTICLES]: {
    title: "Bài viết",
    isPublic: false,
    permission: "article",
  },
  [ROUTES.CREATE_ARTICLE]: {
    title: "Tạo bài viết",
    isPublic: false,
    permission: "article",
  },
  [ROUTES.EDIT_ARTICLE]: {
    title: "Chỉnh sửa bài viết",
    isPublic: false,
    permission: "article",
  },
  [ROUTES.IMAGES]: {
    title: "Hình ảnh",
    isPublic: false,
    permission: "image",
  },
  [ROUTES.PAGES]: {
    title: "Trang",
    isPublic: false,
    permission: "page",
  },
  [ROUTES.CREATE_PAGE]: {
    title: "Tạo trang",
    isPublic: false,
    permission: "page",
  },
  [ROUTES.EDIT_PAGE]: {
    title: "Chỉnh sửa trang",
    isPublic: false,
    permission: "page",
  },
  [ROUTES.BLOG_POSTS]: {
    title: "Blog Post",
    isPublic: false,
    permission: "blog_post",
  },
  [ROUTES.CREATE_BLOG_POST]: {
    title: "Tạo Blog Post",
    isPublic: false,
    permission: "blog_post",
  },
  [ROUTES.EDIT_BLOG_POST]: {
    title: "Chỉnh sửa Blog Post",
    isPublic: false,
    permission: "blog_post",
  },
  [ROUTES.MENUS]: {
    title: "Menu",
    isPublic: false,
    permission: "menu",
  },
  [ROUTES.SIDEBAR]: {
    title: "Sidebar",
    isPublic: false,
    permission: "widget",
  },
  [ROUTES.TRENDING_MOVIES]: {
    title: "Phim Thịnh Hành",
    isPublic: false,
    permission: "widget",
  },
  [ROUTES.FILM_LIST]: {
    title: "Danh sách phim",
    isPublic: false,
    permission: "film_list",
  },
  [ROUTES.AUTHORS]: {
    title: "Tác giả",
    isPublic: false,
    permission: "author",
  },
  [ROUTES.ROBOT_TXT]: {
    title: "Robot.txt",
    isPublic: false,
    permission: "robot_txt",
  },
  [ROUTES.WIDGETS]: {
    title: "Widget",
    isPublic: false,
    permission: "widget",
  },
  [ROUTES.COMMENTS]: {
    title: "Bình luận",
    isPublic: false,
    permission: "comment",
  },
  [ROUTES.INFORMATION]: {
    title: "Thông tin",
    isPublic: false,
    permission: "information",
  },
  [ROUTES.SETTINGS]: {
    title: "Cài đặt",
    isPublic: false,
  },
  [ROUTES.PROFILE]: {
    title: "Hồ sơ",
    isPublic: false,
  },
  [ROUTES.REDIRECTIONS]: {
    title: "Chuyển hướng",
    isPublic: false,
    permission: "page",
  },
  // [ROUTES.SERIES]: {
  //     title: 'Phim bộ',
  //     isPublic: false,
  //     permission: 'article',
  // },
  [ROUTES.HOME]: {
    title: "Dashboard",
    isPublic: false,
  },
  [ROUTES.ACTORS]: {
    title: "Diễn viên",
    isPublic: false,
    permission: "actor",
  },
  [ROUTES.CREATE_ACTOR]: {
    title: "Thêm diễn viên",
    isPublic: false,
    permission: "actor",
  },
  [ROUTES.EDIT_ACTOR]: {
    title: "Chỉnh sửa diễn viên",
    isPublic: false,
    permission: "actor",
  },
  [ROUTES.DIRECTORS]: {
    title: "Đạo diễn",
    isPublic: false,
    permission: "director",
  },
  [ROUTES.CREATE_DIRECTOR]: {
    title: "Thêm đạo diễn",
    isPublic: false,
    permission: "director",
  },
  [ROUTES.EDIT_DIRECTOR]: {
    title: "Chỉnh sửa đạo diễn",
    isPublic: false,
    permission: "director",
  },
  [ROUTES.KKMOVIES]: {
    title: "KKMovie",
    isPublic: false,
    permission: "kkmovie",
  },
  [ROUTES.KKMOVIE_EPISODES]: {
    title: "Tập phim KKMovie",
    isPublic: false,
    permission: "kkmovie",
  },
  [ROUTES.KKPHIM_SYNC]: {
    title: "KKPhim Sync",
    isPublic: false,
    permission: "kkphim_sync",
  },
  [ROUTES.OPHIM_SYNC]: {
    title: "OPhim Sync",
    isPublic: false,
    permission: "ophim_sync",
  },
  [ROUTES.MOVIE_IMPORT]: {
    title: "Import Phim",
    isPublic: false,
    permission: "article",
  },
  [ROUTES.CACHE]: {
    title: "Quản lý Cache",
    isPublic: false,
    permission: "information",
  },
} as const;

// Type definitions
export type RouteKey = keyof typeof ROUTES;
export type RoutePath = (typeof ROUTES)[RouteKey];
